module.exports = __webpack_public_path__ + "static/media/voxwizard-3.71d635fe.jpg";